import { Spinner } from "@ui/components/feedback/spinner/Spinner";
import { Box } from "@ui/components/layout/box/Box";
import React from "react";

export const SpinnerBox = () => {
    return (
        <Box
            position={"relative"}
            left={0}
            right={0}
            minH={"50vh"}
            w="full"
            display={"flex"}
            justifyContent="center"
            alignItems={"center"}
            bg="gray.50"
        >
            <Spinner size={"xl"} color="black" />
        </Box>
    );
};
